import React, { useState } from 'react';

import BlurPopup from 'components/BlurPopup';
import { Button } from 'components/Buttons/Button';
import { ButtonType } from 'enums/ButtonType';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { clearApplication } from 'actions/application';
import { setDashboardStep } from 'actions/stages';
import { DashboardStep } from 'enums/DashboardStep';
import Loader from 'components/Loader';
import { WarningIcon } from 'assets/icons';
import * as notificationManager from 'notifications/index';
import { LoadingType, setLoadingState } from 'actions';
import { useAppSelector } from 'hooks/useAppSelector';
import { offersApi } from 'api/OffersApi';

import styles from './DeclineOfferPopup.module.scss';

interface DeclineOfferPopupProps {
  isModalOpen: boolean;
  applicationId: string;
  onClose: () => void;
}

const DeclineOfferPopup = ({ isModalOpen, applicationId, onClose }: DeclineOfferPopupProps) => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.loading[LoadingType.GetData]);
  const [isWithdrawn, setIsWithdrawn] = useState(false);

  const handleWithdrawApplication = async () => {
    try {
      dispatch(setLoadingState({ type: LoadingType.GetData, loading: true }));

      await offersApi.declineOffer({ applicationId: applicationId!, isWithdrawn: true });

      setIsWithdrawn(true);
    } catch (error: any) {
      onClose();
      notificationManager.notifyFailure(notificationManager.FailureNotificationType.UnknownError);
    } finally {
      dispatch(setLoadingState({ type: LoadingType.GetData, loading: false }));
    }
  };

  const handleClosePopup = () => {
    onClose();
    dispatch(clearApplication());
    dispatch(setDashboardStep(DashboardStep.NoActiveApplication));
  };

  return (
    <>
      <BlurPopup
        id="popup"
        classes={{
          paper: styles.paper,
          container: styles.container,
        }}
        onClose={handleClosePopup}
        open={isModalOpen}
        scroll="body"
        blurDeep={2}
        isCloseButtonDisplayed={isWithdrawn}
      >
        {loading ? (
          <Loader customContainerClassname={styles.loaderContainer} />
        ) : isWithdrawn ? (
          <div className={styles.loanCanceledPopup}>
            <WarningIcon className={styles.warningIcon} />
            <div className={styles.loanCanceledPopupText}>Your loan request has been canceled.</div>
          </div>
        ) : (
          <div className={styles.loanCanceledPopup}>
            <div className={styles.header}>Are You Sure You Want To Withdraw Your Loan Request?</div>
            <div className={styles.buttonsContainer}>
              <Button className={styles.button} onClick={onClose}>
                No, I am still interested
              </Button>
              <Button buttonType={ButtonType.Secondary} className={styles.button} onClick={handleWithdrawApplication}>
                Yes, cancel my loan
              </Button>
            </div>
          </div>
        )}
      </BlurPopup>
    </>
  );
};

export default DeclineOfferPopup;
